import Regime from 'modules/contracts/store/models/Regime'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class Regimes extends PayrollLegalEntityResource<Regime> {
  get cacheKey(): string {
    return 'regimes'
  }

  model() {
    return Regime
  }
}

export { Regimes }
